<script lang="ts" setup>
const { t: $t } = useI18n()

import type { ApiMachineryPublicBaseSelect } from '~/layers/customer-module/types'

const props = defineProps<{ machinery?: ApiMachineryPublicBaseSelect | null, isLoading?: boolean }>()

const machineryPublicBatteryData = computed((): OneDataColumn<ApiMachineryPublicBaseSelect>[] => [
  {
    title: $t('customerModule.machinery.details.machinery.batteryDataColumn.producer'),
    key: 'receptionMachinery',
    render: ({ receptionMachinery }) => receptionMachinery?.battery?.producerCompanyName,
  },
  {
    title: $t('customerModule.machinery.details.machinery.batteryDataColumn.type'),
    key: 'receptionMachinery',
    render: ({ receptionMachinery }) => receptionMachinery?.battery?.typeName,
  },
  {
    title: $t('customerModule.machinery.details.machinery.batteryDataColumn.weight'),
    key: 'receptionMachinery',
    render: ({ receptionMachinery }) => receptionMachinery?.battery?.weight?.toLocaleString('de-DE'),
  },
  {
    title: $t('customerModule.machinery.details.machinery.batteryDataColumn.volt'),
    key: 'receptionMachinery',
    render: ({ receptionMachinery }) => receptionMachinery?.battery?.volt,
  },
  {
    title: $t('customerModule.machinery.details.machinery.batteryDataColumn.yearBuilt'),
    key: 'receptionMachinery',
    render: ({ receptionMachinery }) => receptionMachinery?.battery?.yearBuilt,
  },
])

const showCard = computed(() => {
  const { battery } = props.machinery?.receptionMachinery ?? {}
  if (!battery) {
    return false
  }

  const { producerCompanyName, typeName, weight, volt, yearBuilt } = battery
  return Boolean(producerCompanyName || typeName || weight || volt || yearBuilt)
})
</script>

<template>
  <CustomerModuleDataCard v-if="showCard" :title="$t('customerModule.machinery.details.machinery.batteryData')" :is-loading="isLoading">
    <TableOneDataColumn :config="{ data: machinery, columns: machineryPublicBatteryData }" class="text-base" />
  </CustomerModuleDataCard>
</template>
